"use strict";

var _type = require("../_utils/type");
var InputSizeTypes = (0, _type.tuple)('l', 'default', 's');
var MobileInputSizeTypes = (0, _type.tuple)('xxl', 'default');
var InputStatusTypes = (0, _type.tuple)('error');
var InputWidthTypes = (0, _type.tuple)('default', 'full');